module.exports = __webpack_public_path__ + "img/calculator-illustration-2@2x.0d426e2f.png";